const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "Tentang Perusahaan",
    "termsOfService": "Persyaratan Layanan",
    "privacyPolicy": "Kebijakan Privasi",
    "guaranteeOfRights": "Hak Subjek Data",
    "customerSupport": "Layanan Pelanggan",
    "cookiePolicy": "Kebijakan Cookie",
    "declarationOfSafety": "Deklarasi KeMOanan",
    "youthProtectionPolicy": "Kebijakan Perlindungan Anak dan Remaja",
    "communityPolicy": "Kebijakan Komunitas",
    "probability": "probability",
    "operationPolicy": "Kebijakan Operasional",
    "doNotSell": "Do Not Sell My Personal Information",
    "gameGrade": "게임이용등급",
    "communityPolicyView": "커뮤니티정책",
    "servicePolicy": "서비스정책",
    "termsOfUse": "회원정책",
    "operationPolicyNCJ": "운영방침",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC Privacy Center",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "Legal Documentation",
    "googleAPIDisclosure": "Google API Disclosure",
    "report": "신고하기",
    "serviceConsent": "Persetujuan Layanan NC",
    "careers": "Careers", 
    "termsOfMobile": "모바일게임 약관"
  },
  "footerWords": {
    "gameRelatedLaw": "Informasi Tambahan Sesuai Undang-Undang Terkait Game",
    "brandInformation": "Informasi Nama Perusahaan",
    "copyright": "Hak Cipta",
    "channelingInfo": "NC Corporation hanya bertindak sebagai mediator dalam menyediakan channeling game dalam plaync. NC Corporation tidak menangani langsung penyediaan layanan game maupun transaksi elektronik pada game tersebut.<br>Kewajiban dan tanggung jawab yang berkaitan dengan layanan dari channeling game ada pada perusahaan masing-masing game. NC Corporation tidak bertanggung jawab atas masalah yang terjadi berkaitan dengan game tersebut."
  },
  "infoCS": {
    "businessInformation": "Periksa Informasi Bisnis",
    "infoAddress": "NC Corporation Co-CEO Kim Taek-Jin, Park Byung-Moo, Nomor Register Perusahaan 220-81-43000 E-commerce Registration: 2026-Seongnam Bundang A-0316",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "Alamat: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republik Korea Layanan Pelanggan: +82-1600-0020 FAX: +82-2-2186-3550",
    "pc": "Alamat: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republik Korea Layanan Pelanggan: +82-1600-0020 FAX: +82-2-2186-3550",
    "ncfamilyzone": "Alamat: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republik Korea Layanan Pelanggan: +82-1600-0020 FAX: +82-2-2186-3550",
    "other": "Alamat: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republik Korea Layanan Pelanggan: +82-1600-0020 FAX: +82-2-2186-3550",
    "none": "",
    "infoEmail": "Email",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-ncfamilyzone": "ncfamilyzone@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(Game PC)/MobileCS@ncsoft.com/(Game Mobile)",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "Judul",
    "jpGenre": "Genre",
    "jpPrice": "Harga",
    "jpPriceValue": "Gratis (termasuk pembelian dalam aplikasi)",
    "jpOs": "Sistem Operasi",
    "jpPlatform": "Platform",
    "jpDevelopedBy": "Developer/Operator",
    "jpReleaseDay": "Tanggal Rilis",
    "jpReleaseDayValue_LW": "04 Novemver 2021"
  },
  "country": {
    "KR": "Republik Korea",
    "TW": "Taiwan",
    "RU": "Rusia",
    "MY": "Malaysia",
    "SA": "Arab Saudi",
    "SG": "Singapura",
    "AE": "Uni Emirat Arab",
    "ID": "Indonesia",
    "JP": "Jepang",
    "QA": "Qatar",
    "TH": "Thailand",
    "PH": "Filipina",
    "HK": "Hong Kong",
    "UA": "Ukraina",
    "BY": "Belarus",
    "LT": "Lituania",
    "PL": "Polandia",
    "GR": "Yunani",
    "IL": "Israel",
    "KW": "Kuwait",
    "AT": "Austria",
    "US": "Amerika Serikat",
    "CA": "Kanada",
    "DE": "Jerman",
    "GB": "Britania Raya",
    "FR": "Prancis",
    "BR": "Brasil",
    "IT": "Italia",
    "ES": "Spanyol",
    "CL": "Chili",
    "NO": "Norwegia",
    "SE": "Swedia",
    "IE": "Irlandia",
    "PT": "Portugal",
    "FI": "Finlandia",
    "DK": "Denmark",
    "CH": "Swiss",
    "AR": "Argentina",
    "PE": "Peru",
    "MX": "Meksiko",
    "KZ": "Kazakstan",
    "UZ": "Uzbekistan",
    "AZ": "Azerbaijan",
    "GE": "Georgia",
    "MD": "Moldova",
    "AM": "Armenia",
    "MO": "Makau",
    "IN": "India",
    "PK": "Pakistan",
    "NL": "Belanda",
    "RO": "Rumania",
    "AU": "Australia",
    "TR": "Turki",
    "EC": "Ekuador",
    "CO": "Kolombia",
    "ZA": "Afrika Selatan",
    "EG": "Mesir",
    "NC": "Global"
  }
};

export default l10n;
